<template>
  <div>
    <template v-if="!patientRecordFlag && !loading">
      <div class="sa-mob-header">
        <h5 class="sa-card-tit">My appointments</h5>
        <button
          class="sa-btn-back"
          @click="$router.push('/appointments?stid=all&app_stat=3')"
        >
          <i class="icon-arrow-left"></i>
        </button>
      </div>
      <div class="sa-mob-cont">
        <ul class="sa-card-list-gray">
          <li>
            <div class="sa-card-list-box">
              <figure class="sa-avt-img">
                <img
                  v-if="d && d.img"
                  :src="d.img"
                  alt="Doctor"
                  class="sa-img-cover"
                />
                <img
                  v-else
                  :src="unknownImg"
                  alt="Doctor"
                  class="sa-img-cover"
                />
              </figure>
              <div class="sa-doct-det">
                <h6 v-if="userInfo.utid == '1' || userInfo.utid == '4'">
                  {{ d && d.fn }} {{ d && d.ln }}
                </h6>
                <h6>{{ d && d.pname }}</h6>
                {{ d && d.st_nm }}
              </div>
              <div class="sa-doct-apoint">
                Appointment ID : {{ d && d.apnt_id }}
                <span class="sa-doct-apoint-time">
                  {{ d.time }}
                  <dfn>{{ d.strt_tym }}</dfn>
                </span>
              </div>
            </div>
            <div class="sa-ins-apt">
              <span v-if="d && d.refill" class="sa-refill">Refill</span>
              <span class="sa-bupa-str" v-if="d && d.sales_channel == 'bupa'">
              <i class="icon-Insurance2"></i> Bupa Appointment</span>
              <span class="sa-bupa-str" v-else-if="d && d.sales_channel == 'bupa_refill'">
              <i class="icon-Insurance2"></i> Bupa Appointment</span>
            </div>
            <!-- <div class="sa-card-list-box2 sa-h-xs" v-if="d && d.status == '9' || d && d.status == '3'">
            Ph : +{{d && d.pc}} {{d && d.ph}}
            <button
                :disabled="!d.enableChat"
                class="sa-btn sa-btn-primary"
                @click="chartPanel"
              >
                Start chat
                <i class="icon-chat2"></i>
              </button>
            <button
              v-if="d && d.stid == 'ST1'  && d.status == '7' || d.status == '9'"
              class="sa-btn sa-btn-primary"
              @click="chartPanel"
            >
              Start chat
              <i class="icon-chat2"></i>
            </button> -->
            <!-- </div> -->
          </li>
          <li>
            <div class="sa-card sa-card-noshow">
              <div class="sa-row">
                <div
                  class="sa-col-xs12 sa-col-sm4 sa-col-md4 sa-col-lg4"
                  v-if="userInfo.utid == '1'"
                >
                  <div class="sa-form-group">
                    <label>Gender</label>
                    <span>{{ d && d.gnd }}</span>
                  </div>
                </div>
                <div
                  class="sa-col-xs12 sa-col-sm4 sa-col-md4 sa-col-lg4"
                  v-if="userInfo.utid == '1'"
                >
                  <div class="sa-form-group">
                    <label>Birthday </label>
                    <span>{{ d.dob }}</span>
                  </div>
                </div>
                <div
                  class="sa-col-xs12 sa-col-sm4 sa-col-md4 sa-col-lg4"
                  v-if="userInfo.utid == '1'"
                >
                  <div class="sa-form-group">
                    <label>User Name </label>
                    <span>{{ d.fn }} {{ d.ln }}</span>
                  </div>
                </div>
                <div
                  class="sa-col-xs12 sa-col-sm4 sa-col-md4 sa-col-lg4"
                  v-if="userInfo.utid == '1'"
                >
                  <div class="sa-form-group">
                    <label>Relationship </label>
                    <span>{{ d.relation }}</span>
                  </div>
                </div>
                <div
                  class="sa-col-xs12 sa-col-sm4 sa-col-md6 sa-col-lg4"
                  v-if="
                    ((d && d.status == '3') || (d && d.status == '9')) &&
                    d &&
                    d.emph != ''
                  "
                >
                  <div class="sa-form-group">
                    <label>Emergency Contact</label>
                    +{{ d && d.empc }} {{ d && d.emph }}
                  </div>
                </div>
                <div
                  class="sa-col-xs12 sa-col-sm4 sa-col-md6 sa-col-lg4"
                  v-if="userInfo.utid == '1'"
                >
                  <div class="sa-form-group">
                    <label>Nationality</label>
                    <span>{{ d.natio }}</span>
                  </div>
                </div>
                <div
                  class="sa-col-xs12 sa-col-sm4 sa-col-md6 sa-col-lg4"
                  v-if="userInfo.utid == '1'"
                >
                  <div class="sa-form-group">
                    <label>Identity No </label>
                    <span>{{ d.identity }}</span>
                  </div>
                </div>
              </div>
              <!-- <div class="sa-form-group sa-mb0">
            <label>Previously added reports</label>
            <a :href="i.url" class="sa-d-f-a-center sa-mt10" target="_blank" v-if="d && d.invsts.length > 0" v-for="i in d && d.invsts" :key="i.file_nm">
              <i class="icon-pdf sa-red-text sa-f-size18"></i>
              <span class="sa-blue-text sa-ml10 sa-ellipsis">{{i.file_nm}}</span>
            </a>
            <span v-if="d && d.invsts.length==0">No Reports added Previously</span>
          </div> -->

              <hr />

              <div
                class="sa-mb20 sa-reports_multiple"
                v-if="
                  d && d.reports && d.reports.length > 0 && d.status !== '5'
                "
              >
                <strong class="sa-d-block sa-darkblue-text">Reports </strong>
                <!-- <a :href="i.url" class="sa-d-f-a-center sa-mt10 sa-f-up-info" target="_blank" :v-if=" d && d.reports.length > 0" v-for="i in d && d.reports" :key="i.file_nm">
                      <img :src="i.url" class="sa-img-cover sa-mr5" v-if="isImage(getFileExtension(i.file_nm))" />
                      <i :class="`icon-${getFileExtension(i.url).toLowerCase()}`" class=" sa-f-size18" v-else></i>
              <span class="sa-blue-text sa-ml10 sa-ellipsis">{{i.file_nm}}</span>
            </a> -->
                <file-upload-multiple
                  :pflag="pflag"
                  :fileData="
                    d.reports.map((_) => ({ file_nme: _.file_nm, url: _.url }))
                  "
                  :show-upload="false"
                  :showName="true"
                />
                <span class="sa-mt10" v-if="d && d.reports && d.reports.length == 0"
                  >No Reports added</span
                >
              </div>
              <div class="sa-mb20" v-if="d && (d.voice_note || d.note) && d.status !== '5'" >
                 <strong v-if="d && d.sales_channel=='bupa_refill'" class="sa-d-block sa-darkblue-text"
                  >Chief Complaint</strong
                >
                <strong v-else class="sa-d-block sa-darkblue-text"
                  >Patient Comments</strong
                >
                
                <span v-if="d && d.voice_note">
                  <label>Voice Note</label>
                  <audio-player :audioClip="d && d.voice_note"
                /></span>
                <!-- <a :href="d && d.reason_att" class="sa-d-f-a-center sa-mt10" target="_blank" v-if="d && d.reason_att!=''">
              <i class="icon-pdf sa-red-text sa-f-size18"></i>
              <span class="sa-blue-text sa-ml10 sa-ellipsis">{{d && d.reason_att}}</span>
            </a> -->
                <span class="sa-mt10" v-if="d && d.voice_note == ''"
                  >No patient comments added</span
                >
              </div>
              <!-- <div class="sa-mb20">
            <strong class="sa-d-block sa-darkblue-text sa-mb5"></strong>
          </div> -->
              <div class="sa-card sa-mb20" v-if="d && d.note != ''">
                {{ d && d.note }}
              </div>
              <div
                v-if="
                  d.patient_records &&
                  (d.patient_records.bookings_count ||
                    (d.patient_records.records &&
                      d.patient_records.records.count))
                "
                class="sa-card sa-card-green sa-card-noshadow"
              >
                <div class="sa-row">
                  <div class="sa-col-xs6 sa-col-sm8 sa-col-md8 sa-col-lg8">
                    <strong>Patient Records</strong>
                  </div>
                  <div
                    v-if="d.patient_records.bookings_count"
                    class="sa-col-xs6 sa-col-sm4 sa-col-md4 sa-col-lg4 sa-text-right"
                  >
                    <span class="sa-f-size12"
                      >{{ d.patient_records.bookings_count }}
                      {{
                        d.patient_records.bookings_count > 1
                          ? "Bookings"
                          : "Booking"
                      }}</span
                    >
                  </div>
                  <div
                    class="sa-col-xs6 sa-col-sm8 sa-col-md8 sa-col-lg8 sa-mt20"
                  >
                    <span
                      v-if="
                        d.patient_records.records &&
                        d.patient_records.records.count
                      "
                      class="sa-d-flex sa-text-left sa-precords"
                    >
                      <a
                        :href="img"
                        class="sa-avtar sa-avtar-exs"
                        target="_blank"
                        v-for="(img, i) in d.patient_records.records.uploads"
                        :key="i"
                      >
                        <img
                          :src="img"
                          class="sa-img-cover sa-mr5"
                          v-if="isImage(getFileExtension(img))"
                        />
                        <i
                          :class="`icon-${getFileExtension(img).toLowerCase()}`"
                          class="sa-f-size18"
                          v-else
                        ></i>
                      </a>
                      <!-- <file-upload-multiple
                    :pflag="pflag"
                    :fileData="d.patient_records.records.uploads.map(_=> ({file_nme: _, url: _}))" :show-upload="false" :showName="false"
                  /> -->
                    </span>
                  </div>
                  <div
                    class="sa-col-xs6 sa-col-sm4 sa-col-md4 sa-col-lg4 sa-mt20 sa-text-right"
                  >
                    <a @click="viewRecord" class="sa-text-underline">
                      View Record
                    </a>
                  </div>
                </div>
              </div>
              <problem-list :problems="d.problems"  v-if="d.refill && d.sales_channel == 'bupa_refill'" />
              <div  v-if="d.refill && d.sales_channel == 'bupa_refill'" class="sa-mb20">
                <h5 class="sa-card-tit sa-mt20">Previous prescription</h5>
                <button class="sa-btn sa-btn-large sa-btn-outline-primary sa-btn-block-xs" @click="prevPrescription">Previous prescription</button>
              </div>
               <span
          class="sa-d-block sa-mb20"
          v-if="(noshowflag && d.status == '3') || d.status == '11'"
        >
          <input
            type="checkbox"
            id="NoShow"
            v-model="checkbox"
            name="checkbox"
          />
          <label for="NoShow">No show</label>
        </span>
        <!-- only bupa Refill -->
         <span
          class="sa-d-block sa-mb20"
          v-if="(d.sales_channel == 'bupa_refill' && d.status == '3') || d.status == '11'"
        >
          <input
            type="checkbox"
            id="Incomplete"
            v-model="Incomplete"
            name="Incomplete"
          />
          <label for="Incomplete">Incomplete</label>
        </span>
              <div class="sa-row" v-if="reasonCheck && d.refill && d.sales_channel == 'bupa_refill'">
                  <div class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg4">
                      <div class="sa-form-group">
                          <label>reason</label>
                          <v-select :options="incompleteoption" v-model="inc_reason"
                          placeholder="Select Reason" class="diagno-select" id="PrescriptionStatus" name="Prescription Status" ><span slot="no-options">No data</span></v-select>
                      </div>
                  </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="sa-text-right sa-mt20">
       
        <button class="sa-btn sa-btn-large sa-btn-outline-primary sa-btn-block-xs" v-if="d.reschedule" @click="resheduleApt">Reschedule</button>
        <button
          v-if="
            (d.status == '3' || d.status == '11' || d.status == 12) &&
            !buttonCheck && !reasonCheck && showDiagnosis
          "
          class="sa-btn sa-btn-large sa-btn-primary sa-btn-block-xs"
          :apt="d"
          @click="adddiagnosis(d.apnt_id)"
        >
          <i class="icon-add-diagnosis sa-mr5 sa-f-size18"></i> Add Diagnosis
        </button>
        <button
          v-else-if="buttonCheck && (d.status == '3' || d.status == '11')"
          class="sa-btn sa-btn-large sa-btn-primary sa-btn-block-xs"
          :apt="d"
          @click="noshow(d.apnt_id)"
        >
          Save
        </button>
        <button
          v-else-if="reasonCheck && (d.status == '3' || d.status == '11')"
          class="sa-btn sa-btn-large sa-btn-primary sa-btn-block-xs"
          :apt="d"
          @click="incomplete(d.apnt_id)"
        >
          Save
        </button>
      </div>
      
      
    </template>
    <ResheduleRequest v-if="resheduleModal" @close="closePop"/>
    <patient-record :records="records" :apnt="d" v-if="patientRecordFlag" />
    <follow-up-consultatin
      :apt="d.previous_appnt"
      v-if="d && d.followUp && !patientRecordFlag"
    ></follow-up-consultatin>
    <div v-if="loading">
      <img
        src="../../assets/img/loader.svg"
        alt="loader"
        class="sa-loader sa-loader-top"
      />
    </div>
  </div>
</template>
<script>
import { oh_url } from "../../../config/endpoints";
import moment from "moment";
import moment_time_zone from "moment-timezone";
import AudioPlayerVue from "./AudioPlayer.vue";
import PatientRecordVue from "./PatientRecord.vue";
import { pro_url } from "../../../config/endpoints";
import _ from "lodash";
import FollowUpConsultatin from "../appointments/FollowUpConsultatin.vue";
import FileUploadMultipleVue from "../common/FileUploadMultiple.vue";
import ProblemListVue from './ProblemList.vue';
import ResheduleRequest from "./ResheduleRequest.vue";

export default {
  props: ["d"],
  components: {
    "audio-player": AudioPlayerVue,
    "patient-record": PatientRecordVue,
    "follow-up-consultatin": FollowUpConsultatin,
    "file-upload-multiple": FileUploadMultipleVue,
    "problem-list": ProblemListVue,
    ResheduleRequest
  },
  watch: {
    checkbox: {
      immediate: true,
      handler(val) {
        if (val) {
          this.buttonCheck = true;
        } else {
          this.buttonCheck = false;
        }
      },
    },
    Incomplete: {
      immediate: true,
      handler(val) {
        if (val) {
          this.reasonCheck = true;
        } else {
          this.reasonCheck = false;
        }
      },
    },
  },
  data() {
    return {
      resheduleModal: false,
      chatTime: null,
      reportsfile: [],
      pflag: false,
      patDetails: null,
      presDiag: 0,
      status: {},
      open: {},
      patientRecordFlag: false,
      recordFlag: false,
      records: null,
      loading: false,
      Incomplete:false,
      checkbox: false,
      reasonCheck:false,
      buttonCheck: false,
      noshowflag: false,
      inc_reason:null,
      incompletelist : null,
      incompleteoption: [],
      unknownImg: "https://img.litedev.com/images/unknown-avtar.png",
    };
  },
  computed:{
    showDiagnosis(){
      let _self = this;
      let presentTime = moment().tz("Asia/Riyadh").format();
      const appstartTime = moment(this.d.date + this.d.strt_tym, "YYYY-MM-DDThh:mm A").tz("Asia/Riyadh", true).format();
      const endTime = moment(appstartTime).add(moment.duration(_self.chatTime,"hours")).tz("Asia/Riyadh").format();
      return moment(presentTime).isAfter(moment(appstartTime)) && moment(presentTime).isSameOrBefore(moment(endTime))
    }
  },
  methods: {
    resheduleApt(){
      this.resheduleModal = true
    },
    closePop(){
      this.showPrevPrescription = false
      this.resheduleModal = false
    },
    prevPrescription(){
       this.$router.push('/appointments/doctor-details/previous-prescription/'+this.$route.params.appid)
    },
    getFileExtension(fileName) {
      let fileType = fileName.split(".").pop();
      return fileType;
    },
    isImage(ext) {
      if (!ext) {
        return false;
      }
      const imgFtypes = [
        "jpg",
        "jpeg",
        "png",
        "gif",
        "bmp",
        "tif",
        "tiff",
        "eps",
        "svg",
        "raw",
        "jfif",
      ];
      return imgFtypes.indexOf(ext) !== -1;
    },
    //  isImage(img) {
    //   let fileType = img.split(".").pop();
    //   return fileType;
    // },
    openToggle(i) {
      let _self = this;
      let flag = !_self.open[i];
      _self.$set(_self.open, i, flag);
      _self.presDiag += 1;
    },
    viewRecord() {
      let _self = this;
      _self.loading = true;
      _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/diagnosis/recordDetails`,
          body: {
            apnt_id: _self.patDetails.apnt_id,
            mtype: "records",
          },
        })
        .then((response) => {
          _self.loading = false;
          if (response && response.status === 1000) {
            _self.recordFlag = true;
            _self.patientRecordFlag = true;
            _self.records = response.data;
            _self.records.bookings = _.map(_self.records.bookings, (e) => {
              e.date = e.date ? moment(e.date).format("DD-MMM-YYYY") : "";
              return e;
            });
            // if(!_self.recordFlag) {
            //   _self.recordFlag = true
            //   _self.patientRecordFlag = true
            // }else {
            //   _self.recordFlag = false
            //   _self.patientRecordFlag = false
            // }
          }
        });
    },
    chartPanel() {
      this.$router.push({ path: "/appointments/chat-with-a-doctor" });
    },
    adddiagnosis(aid) {
      let _self = this;
      _self.patDetails.status = _self.d.status;
      _self.patDetails.apnt_date = _self.d.date;
      _self.patDetails.stid = _self.d.stid;
      _self.$localStorage.set("patDetails", JSON.stringify(_self.patDetails));
      _self.$router.push({
        path: "/appointments/doctor-details/add-diagnosis/" + aid,
      });
    },

    getOptions(){
      let _self = this
       _self.$store
        .dispatch("httpGet", {
          uri: `${pro_url}/getIncompleteData`,
        })
        .then((response) => {
          if(response && response.status == 1000){
            this.incompletelist = response.data
            _.map(response.data, e => {
                this.incompleteoption.push(e.reason)
                return e
            })
          }
        })
    },
    noshow() {
      let _self = this;
      console.log(_self.patDetails.apnt_id);
      _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/apt/update`,
          body: {
            apnt_id: _self.patDetails.apnt_id,
            complete: "9",
          },
        })
        .then((response) => {
          _self.loader = false;
          if (response && response.status === 1000) {
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: response.data,
              class: "sa-a-success",
            });
            this.$router.push({ path: `/appointments?stid=all&&app_stat=3` });
          } else {
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: response.message,
              class: "sa-a-danger",
            });
            this.$router.push({ path: `/appointments?stid=all&&app_stat=3` });
          }
        });
    },
    incomplete() {
      let _self = this;
      if(_self.inc_reason){
          console.log("object");
          let inc;
          _.map(this.incompletelist, e =>{
            if(e.reason == _self.inc_reason){
              inc = e.reason_id
              return e
            }else{
              return e
            }
          })
           _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/updateStatus`,
          body: {
            apnt_id: _self.patDetails.apnt_id,
            status: "17",
            inc_reason: inc
          },
        })
        .then((response) => {
          if(response && response.status == 1000){
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: response.message,
              class: "sa-a-success",
            });
            this.$router.push({ path: `/appointments?stid=all&&app_stat=3` });
          }else{
             _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: response.message,
              class: "sa-a-danger",
            });
          }
        })
      }else{
        _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: "Please Select Reason",
              class: "sa-a-danger",
            });
      }
    },
    getChatextraTime() {
      let _self = this;
      _self.$store
        .dispatch("httpPost", {
          uri: `${oh_url}/general/getStaticData`,
          body: { mtype: [] },
        })
        .then((response) => {
          if ((response.status === 1000)) {
            _self.chatTime = Math.floor(response.data.chat_extratime / 3600);
          }
        })
        .catch((e) => {
          console.log(e,'error on static data');
        });
    },
  },
  created() {
    let _self = this;
    _self.userInfo = JSON.parse(_self.$localStorage.get("userdata")) || {};
    _self.patDetails = JSON.parse(_self.$localStorage.get("patDetails"));
  },
  mounted: function () {
    var _self = this;
    _self.getChatextraTime();
    _self.$localStorage.remove("plan");
    if(this.d.sales_channel == 'bupa_refill'){
          this.getOptions()
    }
    setInterval(function () {
      if (_self.d && _self.d.length) {
        _self.d.map((apt) => {
          let presentTime = moment().tz("Asia/Riyadh").format();
          let appStartTime = moment(
            apt.date + apt.strt_tym,
            "YYYY-MM-DDThh:mm A"
          )
            .tz("Asia/Riyadh", true)
            .format();
          let appEndTime = moment(apt.date + apt.end_tym, "YYYY-MM-DDThh:mm A")
            .tz("Asia/Riyadh", true)
            .format();
          if (
            moment(presentTime).isAfter(moment(appStartTime)) &&
            moment(appEndTime).isAfter(moment(presentTime))
          ) {
            _self.$set(apt, "enableChat", true);
          } else {
            _self.$set(apt, "enableChat", false);
          }
        });
      }
    }, 1000);

    let sdt = moment(_self.d.date + _self.d.strt_tym, "YYYY-MM-DDThh:mm A")
      .tz("Asia/Riyadh", true)
      .format();
    let et = moment(sdt)
      .add(moment.duration(4, "hours"))
      .tz("Asia/Riyadh")
      .format("YYYY-MM-DD hh:mm A");
    let dt = moment().format("YYYY-MM-DD hh:mm A");
    // if(et <= dt){
    if (moment(dt).isSameOrAfter(moment(et))) {
      _self.noshowflag = true;
    } else {
      _self.noshowflag = false;
    }
  },
};
</script>
